import { useEffect } from 'react'
import { useAuthStore } from '@/shared/store'
import { usePartner } from '@/features/auth/hooks'

interface AuthInitializerProps {
  children: React.ReactNode
}

export const AuthInitializer = ({ children }: AuthInitializerProps) => {
  const setAuthInitialized = useAuthStore((s) => s.setAuthInitialized)
  const isAuthInitialized = useAuthStore((s) => s.isAuthInitialized)
  const { isLoading } = usePartner()

  useEffect(() => {
    if (!isLoading && !isAuthInitialized) {
      setAuthInitialized()
    }
  }, [isLoading, isAuthInitialized, setAuthInitialized])

  return <>{children}</>
}
